var map = {
	"./circle.svg": "i0d3",
	"./octogone.svg": "Ch64",
	"./oval-h.svg": "C5uB",
	"./oval-v.svg": "YY95",
	"./rectangle.svg": "rzn6",
	"./square.svg": "u0Ls"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "p6tU";